export enum DataUnitSetupCatalogStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DRAFT = 'DRAFT',
  OBSOLETE = 'OBSOLETE'
}

const approvedIconName = 'confirm';
const rejectedIconName = 'cancelled';
const draftIconName = 'draft';
const obsoleteIconName = 'close';

const dataUnitSetupCatalogStatusIconMap: Map<DataUnitSetupCatalogStatus, string> = new Map<DataUnitSetupCatalogStatus, string>([
  [DataUnitSetupCatalogStatus.APPROVED, approvedIconName],
  [DataUnitSetupCatalogStatus.REJECTED, rejectedIconName],
  [DataUnitSetupCatalogStatus.DRAFT, draftIconName],
  [DataUnitSetupCatalogStatus.OBSOLETE, obsoleteIconName]
]);

export namespace DataUnitSetupCatalogStatus {
  export function getStatusIconName(status: DataUnitSetupCatalogStatus): string {
    return dataUnitSetupCatalogStatusIconMap.get(status);
  }

  export function getListOfReviewStatus(currentStatus: DataUnitSetupCatalogStatus): DataUnitSetupCatalogStatus[] {
    let result: DataUnitSetupCatalogStatus[];

    switch (currentStatus) {
      case DataUnitSetupCatalogStatus.DRAFT:
        result = [DataUnitSetupCatalogStatus.DRAFT, DataUnitSetupCatalogStatus.REJECTED, DataUnitSetupCatalogStatus.APPROVED];
        break;
      case DataUnitSetupCatalogStatus.APPROVED:
        result = [DataUnitSetupCatalogStatus.APPROVED, DataUnitSetupCatalogStatus.REJECTED, DataUnitSetupCatalogStatus.OBSOLETE];
        break;
      case DataUnitSetupCatalogStatus.REJECTED:
        result = [DataUnitSetupCatalogStatus.REJECTED, DataUnitSetupCatalogStatus.APPROVED, DataUnitSetupCatalogStatus.OBSOLETE];
        break;
      case DataUnitSetupCatalogStatus.OBSOLETE:
        result = [DataUnitSetupCatalogStatus.OBSOLETE];
        break;
      default:
        result = [];
    }

    return result;
  }
}
